module.exports = __webpack_public_path__ + "static/img/ESGS2022E.fbdfd7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ESGS2022E.png
// module id = wyg/
// module chunks = 1